import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { FindingsModel, webCamModel } from 'app/EMR/DoctorModels/findings.model';
import { FindingGroupdataModel } from 'app/EMR/DoctorModels/findingsubcategorydata.model';
import { EMRService } from 'app/EMR/EMR.service';
import { ExaminationHelpComponent } from 'app/EMR/ExaminationHelp/ExaminationHelp.component';
import { Image_workupComponent } from 'app/EMR/Image_workup/Image_workup.component';
import { OldcaseComponent } from 'app/EMR/oldcase/oldcase.component';
import { OpdSettingComponent } from 'app/EMR/opd-setting/opd-setting.component';
import { TemplateFindingsComponent } from 'app/EMR/TemplateFindings/TemplateFindings.component';
import { Template_helpComponent } from 'app/EMR/template_help/template_help.component';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { PatientdocsComponent } from 'app/table-list/patientdocs/patientdocs.component';
import { Observable, Subject, of, interval } from 'rxjs';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { FindingResultModel } from 'app/EMR/DoctorModels/findingResult.model';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth/auth.service';
import { HelpListPopupComponent } from '../doctor-other-info/help-list-popup/help-list-popup.component';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';



@Component({
  selector: 'app-finding-examination',
  templateUrl: './finding-examination.component.html',
  styleUrls: ['./finding-examination.component.scss']
})
export class FindingExaminationComponent implements OnInit {

  @Input() showdruallergymodel: any;
  @Output() parentdata: EventEmitter<any> = new EventEmitter();
  @Output() findingEmitter = new EventEmitter<() => void>();
  destroyfinding$: Subject<boolean> = new Subject<boolean>();
  private examTypeName: any;
  private findingid: any;
  private examid: any;
  private rightTypeName: any;
  private leftTypeName: any;
  private bothTypeName: any;
  private showspinner: boolean = false;
  private findings_ds: MatTableDataSource<FindingsModel>
  private findinggroupdata: FindingGroupdataModel[] = [];
  private examTypeCtrl: FormControl;
  private examTypeCtrledit: FormControl;
  private filteredexamTypeArray: Observable<any[]>;
  private filteredexamTypeArrayedit: Observable<any[]>;
  private rightTypeCtrl: FormControl;
  private rightTypeCtrledit: FormControl;
  private bothTypeCtrl: FormControl;
  private filteredrightTypeArray: Observable<any[]>;
  private filteredrightTypeArrayedit: Observable<any[]>;
  private leftTypeCtrl: FormControl;
  private leftTypeCtrledit: FormControl;
  private filteredleftTypeArray: Observable<any[]>;
  private filteredleftTypeArrayedit: Observable<any[]>;
  private result_ds: FindingResultModel[] = [];
  private resultArray: any = [];
  private getfindingdata: any = [];
  private displayedColumns_findings: string[] = ['examination', 'righteye', 'lefteye', 'botheye', 'Action'];
  private prescriptionSetting: any;
  private PrintList: any;
  private PrescriptionMedicine: any;
  private PageHeader: any;
  private reporturl: any;
  private Visitdate: any;
  private examdetailArray: any = [];
  private findingComments: String = '';
  private righteyeid: number;
  private lefteyeid: number;
  private selectReportValue: 'Prescription';
  // emrservice.enabledisablebtn: boolean = false;
  private editCache: { [key: string]: any } = {};
  private findId: any;
  private enablebtnSection: boolean = false;
  private cds: any;
  private ars: any;
  private ops: any;
  private allDoc: any;
  private allCss: any;
  private allPrs: any;
  private pyslist: any;
  isheader: boolean = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  private filteredbothTypeArrayedit: Observable<any[]>;



  @ViewChild('rightEyeACTrigger') rightEyeTrigger: MatAutocompleteTrigger;
  @ViewChild('leftEyeACTrigger') leftEyeTrigger: MatAutocompleteTrigger;
  @ViewChild('bothEyeACTrigger') bothEyeTrigger: MatAutocompleteTrigger;

  @ViewChild('rightEyeInput') rightEyeInput: ElementRef<HTMLInputElement>;
  @ViewChild('leftEyeInput') leftEyeInput: ElementRef<HTMLInputElement>;
  @ViewChild('bothEyeInput') bothEyeInput: ElementRef<HTMLInputElement>;




  constructor(private SpeachtotextService: VoiceRecognitionService,
    private dialogRef: MatDialogRef<FindingExaminationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialog: MatDialog, private emrservice: EMRService, private opdvisitService: OpdVisitService, private dashboardService: DashboardService, private datepipe: DatePipe, private authservice: AuthService,
    private imageWorkupService: imageworkupService, private ipdservice: IPDService) {
    this.enablebtnSection = false;
    this.SpeachtotextService.init();
  }

  ngOnInit(): void {
    const complaint_data = () => {
      this.getfindingdatabyRgid(this.opdvisitService.patientdetails.pkRegId);
    };
    this.findingEmitter.emit(complaint_data);
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }

    this.SpeachtotextService.Examinationdisable = true;
    this.emrservice.enabledisablebtn = true;
    this.righteyeid = 0;
    this.lefteyeid = 0;
    // this.examdetailArray =this.emrservice.patientEMRdetail;
    if (this.opdvisitService.patientDrdetaill[0]?.examinationComments == undefined) {
      this.SpeachtotextService.ECtext = null;
    }

    this.GetFindingGroupdata(0, 0, 0)
    this.emrservice.share.pipe(takeUntil(this.destroyfinding$)).subscribe((x: any) => {

      if (x == 2) {
        this.examid = this.emrservice.examid;
        this.getfindingdatabyRgid(this.opdvisitService.patientdetails.pkRegId);
        if (this.examid == 0 || !this.examid) {
          this.transferPreviousRecordModal();
        }
        // this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId,this.opdvisitService.visitid,this.opdvisitService.DoctorIdEmr);
      }
      if (x == 3) {
        this.examid = this.emrservice.examid;
        this.getfindingdatabyRgid(this.opdvisitService.patientdetails.pkRegId);
        if (this.examid == 0 || !this.examid) {
          this.transferPreviousRecordModal();
        }
        // this.findings_ds.data = this.getfindingdata.filter(item => item.fK_ExamId == this.emrservice.examid);
        // this.opdvisitService.patientDrdetaill = this.opdvisitService.patientDrdetaill.filter(item => item.pK_ExamId == this.emrservice.examid);
      }
      if (x == 22) {
        this.examid = this.emrservice.examid;

      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });

    this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());

    // AI Scribe — pre-fill findings from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroyfinding$)).subscribe(() => this.consumeAiFindings());
    interval(1500).pipe(takeUntil(this.destroyfinding$)).subscribe(() => this.consumeAiFindings());

    // this.getfindingdatabyRgid(this.opdvisitService.patientdetails.pkRegId);
    this.GetFindingGroupResult(0);
    this.ExamTypeControll();
    this.rightTypeControll();
    this.leftTypeControll();
    this.selectReportValue = 'Prescription';

    this.updateEdit();
    this.ExamTypeControlledit();
    this.rightTypeControlledit();
    this.leftTypeControlledit();
    this.emrservice.componentClicked$.subscribe(() => {
      if (!this.emrservice.enabledisablebtn) {
        setTimeout(() => {
          if (this.emrservice.examid > 0) {
            this.examid = this.emrservice.examid;
            this.saveExaminationFinding(1);
          }
        }, 500);

      } else {
        setTimeout(() => {
          this.showspinner = false;
        }, 500);
      }
    });
  }
  ngOnDestroy() {
    this.destroyfinding$.next(true);
    this.destroyfinding$.unsubscribe();
    this.findinggroupdata = null;
    this.result_ds = null;
    this.resultArray = null;
    this.getfindingdata = null;
    this.examdetailArray = null;
    this.displayedColumns_findings = null;
    this.captures = null;
    this.enablebtnSection = null;
    this.camvisitid = null;
    this.camexamid = null;
    this.description = null;
    this.actvateeye = null;
    this.imageviewertype = null;
    this.viewimagedata = null;
    this.saveimageobject = null;
    this.showspinner1 = null;
    this.imagearrayshowing = null;
    this.emrservice.transferArray = null;
  }

  /** AI Scribe: pull findings from the pending workup into this grid, then clear. */
  consumeAiFindings(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.findings || !p.findings.length) { return; }
    const shown = (this.findings_ds && this.findings_ds.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }
    this.newlistarrray = shown.slice();
    p.findings.forEach((r: any) => {
      this.newlistarrray.push({
        pK_TempExamDetailId: 0, fK_TemplateId: 0, fk_FindingId: 0, pk_SynchId: 0,
        findingName: r.findingName || '',
        examValues1: r.examValues1 || (r.eye === 'RE' ? (r.specification || '') : ''),
        examValues2: r.examValues2 || (r.eye === 'LE' ? (r.specification || '') : ''),
        BE: r.eye === 'BE' ? (r.specification || r.findingName || '') : '',
        specification: r.specification || r.findingName || '',
        findingSubGroup: null, isHidden: false, isEdit: false, aiSuggested: true,
      });
    });
    this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
    this.emrservice.enabledisablebtn = false;
  }

  /** Per-tab AI fill — applies only this section's slice. */
  aiFillFindings(s: any): void { this.emrservice.applyAiWorkup({ findings: (s && s.findings) || [] }); }

  GetFindingGResultByregid(regid, visitid, docid) {

    this.emrservice.GetFindingGResultByregid(regid, visitid, docid).pipe(takeUntil(this.destroyfinding$)).subscribe((x: any) => {
      this.examdetailArray = [];
      this.emrservice.patientEMRdetail = [];
      this.emrservice.patientEMRdetail = x;
      this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.emrservice.examid);
      this.findingComments = this.examdetailArray[0]?.examinationComments ? this.examdetailArray[0]?.examinationComments : null;

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  startService() {
    this.SpeachtotextService.ECtext = '';
    this.SpeachtotextService.start('Examination Comments');
  }
  stopService() {
    this.opdvisitService.patientDrdetaill[0].examinationComments = this.SpeachtotextService.ECtext;
    this.SpeachtotextService.stop('Examination Comments');
    this.emrservice.enabledisablebtn = false;
  }
  getoptomData(visitid) {
    if (this.emrservice.findingPermission.isAddPermission == true) {
      this.emrservice.getoptomVisitdata(visitid).pipe(takeUntil(this.destroyfinding$)).subscribe((x: any) => {
        if (x.length > 0) {
          x.forEach(item => {
            this.newlistarrray.push({
              pK_TempExamDetailId: 0,
              fK_TemplateId: 0,
              fk_FindingId: item.fk_FindingId,
              pk_SynchId: 0,
              findingName: item.findingName,
              examValues1: item.examValues1,
              examValues2: item.examValues2,
              BE: '',
              specification: item.findingName,
              findingSubGroup: item.findingSubGroup,
              isHidden: false,
              isEdit: false
            });

          })
          this.emrservice.enabledisablebtn = false;
          this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
        } else {
          this.dashboardService.openSnackBar("Records not available in Opto Slit Lamp Examination.", "ok")
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "ok")
    }

  }
  getfindingdatabyRgid(regid) {
    if (regid > 0) {
      this.emrservice.GetFindingByRegId(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroyfinding$)).subscribe(
        data => this.success_ByRegId(data), err => this.failed_opto_ByRegId(err)
      )
    }

  }
  success_ByRegId(data) {

    this.newlistarrray = [];
    this.getfindingdata = [];
    if (data.length > 0) {
      // this.findings_ds.data = [];
      data.forEach(item => {
        this.getfindingdata.push({
          pK_TempExamDetailId: 0,
          fK_TemplateId: 0,
          fk_FindingId: item.fk_FindingId,
          pk_SynchId: 0,
          findingName: item.findingName,
          examValues1: item.examValues1,
          examValues2: item.examValues2,
          BE: '',
          specification: item.specification,
          pK_TranId: item.pK_TranId,
          fK_ExamId: item.fK_ExamId,
          isHidden: item.isHidden,
          isEdit: item.isEdit,
          isDeleted: item.isDeleted,
        });

      });

      const checkdata = this.getfindingdata.filter(item => item.fK_ExamId == this.examid);
      if (checkdata.length > 0) {
        this.findings_ds = new MatTableDataSource(checkdata.slice());
        this.newlistarrray = checkdata;

      } else {
        this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
      }

    } else {
      this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
    }
    this.updateEdit();
  }


  failed_opto_ByRegId(err) {

    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  GetFindingGroupdata(fk_subGroupId, type, searchtype) {
    this.emrservice.GetFindingGroupdata(fk_subGroupId, type, searchtype).pipe(takeUntil(this.destroyfinding$)).subscribe(
      data => this.success_FindingSubdata(data), err => this.failed_FindingSubGroup(err)
    )
  }
  success_FindingSubdata(data) {
    this.findinggroupdata = [];
    this.findinggroupdata = data;
    this.ExamTypeControll();
    this.ExamTypeControlledit();
  }
  GetFindingGroupResult(type) {
    this.emrservice.GetFindingGResult(0, type, 0).pipe(takeUntil(this.destroyfinding$)).subscribe(
      data => this.success_Findingreult(data), err => this.failed_FindingSubGroup(err)
    )
  }
  success_Findingreult(data) {
    this.resultArray = [];
    if (data.length > 0) {
      this.resultArray = data.filter(item => item.isActive = true);
      this.result_ds = data.filter(item => item.isActive = true);
      this.rightTypeControll();
      this.leftTypeControll();
    }
  }
  failed_FindingSubGroup(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //auto complete exam
  getexamTypeobj(e: any) {
    var val = e.option.value;
    this.examTypeName = val.findingName;
    this.findingid = val.pk_FindingId;
    if (this.findingid > 0) {
      this.result_ds = this.resultArray.filter(item => item.fk_FindingId == this.findingid);
      this.rightTypeControll();
      this.leftTypeControll();
    }
  }
  getexamTypeobjedit(e: any, index: any) {
    const selectedFindingName = e.option.value;
    const selectedFindingId = e.option.id;

    this.editCache[index].data.findingName = selectedFindingName;
    this.editCache[index].data.fk_FindingId = selectedFindingId;
    this.findings_ds.data[index].findingName = selectedFindingName;
    this.findings_ds.data[index].fk_FindingId = selectedFindingId;

    this.editCache[index].data.rightEyeArray = [];
    this.editCache[index].data.leftEyeArray = [];
    this.editCache[index].data.bothEyeArray = [];

    this.findings_ds.data[index].examValues1 = '';
    this.findings_ds.data[index].examValues2 = '';
    this.findings_ds.data[index].BE = '';

    this.editCache[index].data.rightEyeCtrl.setValue('');
    this.editCache[index].data.leftEyeCtrl.setValue('');
    this.editCache[index].data.bothEyeCtrl.setValue('');

    this.result_ds = this.resultArray.filter(
      item => item.fk_FindingId == selectedFindingId
    );

    this.rightTypeControlledit();
    this.leftTypeControlledit();
  }

  CheckinputexamType(event: any) {
    //  this.examTypeName=null;
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.ExamTypeControll();
      //  this.opTypeId = 0;
      this.findingid = 0;
      this.examTypeName = null;
    }
  }

  ExamTypeControll() {

    this.examTypeCtrl = new FormControl();
    this.filteredexamTypeArray = this.examTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat, 1) : this.findinggroupdata.slice())
      );

  }
  ExamTypeControlledit() {

    this.examTypeCtrledit = new FormControl();
    this.filteredexamTypeArrayedit = this.examTypeCtrledit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat, 2) : this.findinggroupdata.slice())
      );

  }
  newexamfindingArray: any = [];
  filterOpfunction(value: any, type) {

    if (value && (typeof value != 'number')) {
      const filterValue = value.toString().toLowerCase();
      const returndata = this.findinggroupdata.filter(country =>
        country.findingName?.toLowerCase().indexOf(filterValue) === 0);
      if (returndata.length == 0 && value.length >= 3) {
        this.emrservice.GetFindingGroupdata(0, value, 0).pipe(takeUntil(this.destroyfinding$)).subscribe((x: any) => {
          this.newexamfindingArray = [];
          this.newexamfindingArray = x;
          if (type == 1) {
            this.filteredexamTypeArray = this.examTypeCtrl.valueChanges
              .pipe(
                startWith(""),
                map(cat => this.newexamfindingArray.slice())
              );
          } else if (type == 2) {
            this.filteredexamTypeArrayedit = this.examTypeCtrledit.valueChanges
              .pipe(
                startWith(""),
                map(cat => this.newexamfindingArray.slice())
              );
          }

        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
      } else {
        return returndata;
      }
    }
  }

  // autocomplete right eye
  getrightTypeobj(e: any) {

    var val = e.option.value;
    this.righteyeid = val.pK_TranId;
    this.rightTypeName = val.result;
    //  this.findingid = val.pk_FindingId;
    //  this.examid=val.fK_SubGroupId;

  }
  // autocomplete right eye
  getrightTypeobjedit(e: any, i: any) {

    this.editCache[i].data.examValues1 = e.option.value;
    this.editCache[i].data.BE = '';
    this.findings_ds.data[i].examValues1 = e.option.value;

  }
  getbeTypeobjedit(e: any, i: any) {

    this.editCache[i].data.examValues1 = e.option.value;
    this.editCache[i].data.examValues2 = e.option.value;
    this.editCache[i].data.BE = e.option.value;
    this.findings_ds.data[i].examValues1 = e.option.value;
    this.findings_ds.data[i].examValues2 = e.option.value;
  }

  CheckinputrightType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.rightTypeControll();
      //  this.opTypeId = 0;
      this.righteyeid = 0;
      this.rightTypeName = null;
    }
  }

  rightTypeControll() {
    this.rightTypeCtrl = new FormControl();
    this.filteredrightTypeArray = this.rightTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterrightfunction(cat) : this.result_ds.slice())
      );

  }


  onBothEyeInput(event: any) {
    const value = event.target.value;
    this.rightTypeName = value;
    this.leftTypeName = value;
    this.bothTypeName = value;

    this.rightTypeCtrl.setValue(value);
    this.leftTypeCtrl.setValue(value);
  }


  getBothEyeobj(e: any) {
    const val = e.option.value;
    this.bothTypeName = val.result;
    this.rightTypeName = val.result;
    this.leftTypeName = val.result;

    this.righteyeid = val.pK_TranId;
    this.lefteyeid = val.pK_TranId;

    this.rightTypeCtrl.setValue(val.result);
    this.leftTypeCtrl.setValue(val.result);
    // this.bothTypeCtrl.setValue(val.result);
  }





  rightTypeControlledit() {
    this.rightTypeCtrledit = new FormControl();
    this.filteredrightTypeArrayedit = this.rightTypeCtrledit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterrightfunction(cat) : this.result_ds.slice())
      );

  }


  bothTypeControlledit() {
    this.bothTypeCtrl = new FormControl();
    this.filteredbothTypeArrayedit = this.bothTypeCtrl.valueChanges.pipe(
      startWith(''),
      map((typedValue: string) => {
        if (!typedValue) {
          return this.result_ds;
        }
        const filterValue = typedValue.toLowerCase();
        return this.result_ds.filter(opt =>
          opt.result?.toLowerCase().includes(filterValue)
        );
      })
    );
  }

  filterrightfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.result_ds.filter(country =>
      country.result?.toLowerCase().indexOf(filterValue) === 0);

  }

  getleftTypeobj(e: any) {
    var val = e.option.value;
    this.leftTypeName = val.result;
    this.lefteyeid = val.pK_TranId;
  }
  getleftTypeobjedit(e: any, i: any) {
    // var val = e.option.value;    
    this.editCache[i].data.examValues2 = e.option.value;
    this.editCache[i].data.BE = '';
    this.findings_ds.data[i].examValues2 = e.option.value;
    // this.lefteyeid=val.pK_TranId;
  }


  CheckinputleftType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.leftTypeControll();
      //  this.opTypeId = 0;
      this.lefteyeid = 0;
      this.leftTypeName = null;
    }
  }

  leftTypeControll() {
    this.leftTypeCtrl = new FormControl();
    this.filteredleftTypeArray = this.leftTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterleftfunction(cat) : this.result_ds.slice())
      );

  }
  leftTypeControlledit() {
    this.leftTypeCtrledit = new FormControl();
    // this.bothTypeCtrl = new FormControl();
    this.filteredleftTypeArrayedit = this.leftTypeCtrledit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterleftfunction(cat) : this.result_ds.slice())
      );

  }
  // beTypeControlledit() {
  //   this.bothTypeCtrl = new FormControl();
  //   this.filteredleftTypeArrayedit = this.leftTypeCtrledit.valueChanges
  //     .pipe(
  //       startWith(''),
  //       map(cat => cat ? this.filterleftfunction(cat) : this.result_ds.slice())
  //     );

  // }
  filterleftfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.result_ds.filter(country =>
      country.result?.toLowerCase().indexOf(filterValue) === 0);

  }
  ClearfindingValue(type) {
    switch (type) {
      case (1): {
        if (this.findings_ds.data.length > 0) {
          this.deleterExamarray = [];
          this.findings_ds.data.forEach((item: any) => {
            if (item.pK_TranId > 0) {
              this.deleterExamarray.push({
                "PK_TranId": item.pK_TranId,
                "FK_ExamId": item.fK_ExamId,
                "Fk_FindingId": item.fk_FindingId,
                "ExamValues1": item.examValues1,
                "ExamValues2": item.examValues2,
                "Specification": item.findingName,
                "IsDeleted": 1,
                "isEdit": true
              });
            }
          })
        }
        this.newlistarrray = [];
        this.findings_ds.data = [];
        this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
        break;
      }
      case (2): {
        if (this.newlistarrray.length > 0) {
          this.newlistarrray.map(d => d.examValues1 = '');
          this.findings_ds.data = this.newlistarrray;
          break;
        } else {
          this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
        }
      }
      case (3): {
        if (this.newlistarrray.length > 0) {
          this.newlistarrray.map(d => d.examValues2 = '');
          this.findings_ds.data = this.newlistarrray;
          break;
        } else {
          this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
        }
      }
    }
  }
  // list of exam list
  newlistarrray: any = [];

  addExamlist() {

    if (this.emrservice.findingPermission.isAddPermission == true) {
      // this.findings_ds.data = [];

      if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
        if (this.examTypeName != null && this.leftTypeName != null && this.rightTypeName != null && this.findingid != undefined && this.findingid != 0 || this.lefteyeid != 0 || this.righteyeid != 0) {
          let checkfinding = this.newlistarrray.filter(item => item.fk_FindingId == this.findingid);
          if (checkfinding.length == 0) {
            this.newlistarrray.push({
              pK_TempExamDetailId: 0,
              fK_TemplateId: 0,
              fk_FindingId: this.findingid,
              pk_SynchId: 0,
              findingName: this.examTypeName,
              examValues1: this.rightTypeName,
              examValues2: this.leftTypeName,
              BE: this.bothTypeName,
              specification: this.examTypeName,
              findingSubGroup: null,
              isHidden: false,
              isEdit: false
            });
          } else {
            this.dashboardService.openSnackBar("This Record Aleady Exists", "OK");
          }


          this.examTypeName = null;
          this.leftTypeName = null;
          this.rightTypeName = null;
          this.bothTypeName = null;
          this.findingid = 0;
          this.lefteyeid = 0;
          this.righteyeid = 0;
          // this.findings_ds.data = this.newlistarrray;
          this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
          this.emrservice.enabledisablebtn = false;
          this.updateEdit();
        } else {
          this.dashboardService.openSnackBar("Please Select All Field", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Please Select Visit List First", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  removeRow(row: any) {

    const index: number = this.newlistarrray.indexOf(row);
    if (index !== -1) {
      if (row.pK_TranId == 0) {
        this.newlistarrray.splice(index, 1);
        this.findings_ds.data = this.newlistarrray;
        // this.deleteExamdata(row, 1);
      } else {
        if (this.emrservice.findingPermission.isDeletePermission == true) {
          if (Date.parse(this.datepipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
            this.newlistarrray.splice(index, 1);
            this.findings_ds.data = this.newlistarrray;
            this.deleteExamdata(row, 1);
          } else {
            this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Delete permission denied", "ok");
        }
      }

    }

  }
  deleterExamarray: any = [];
  deleteExamdata(rowdata, type) {
    if (Date.parse(this.datepipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
      if (this.authservice.Loggeduser.usertypeid == 6) {
        if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {

          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      this.deleterExamarray = [];
      this.showspinner = true;
      if (type == 1) {
        if (rowdata.pK_TranId > 0) {
          this.deleterExamarray.push({
            "PK_TranId": rowdata.pK_TranId,
            "FK_ExamId": rowdata.fK_ExamId,
            "Fk_FindingId": rowdata.fk_FindingId,
            "ExamValues1": rowdata.examValues1,
            "ExamValues2": rowdata.examValues2,
            "Specification": rowdata.specification,
            "IsDeleted": 1,
            "isEdit": true
          });
        }

      } else {
        rowdata?.forEach(item => {
          if (item.pK_TranId > 0) {
            this.deleterExamarray.push({
              "PK_TranId": item.pK_TranId,
              "FK_ExamId": item.fK_ExamId,
              "Fk_FindingId": item.fk_FindingId,
              "ExamValues1": item.examValues1,
              "ExamValues2": item.examValues2,
              "Specification": item.specification,
              "IsDeleted": 1,
              "isEdit": true
            });
          }

        })
      }
      if (this.deleterExamarray.length > 0) {
        this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
        this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
        this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
        this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
        let payload = {

          DrExam: {
            ...this.opdvisitService.patientDrdetaill[0]

          },

          DrFinding: this.deleterExamarray
          ,
          DrDiag: [
          ],
          DrPrescrip: [
          ],
          DrInvest: []
          , DrSurgery: []
        }
        this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroyfinding$)).subscribe(data => {
          this.showspinner = false;
          if (data['statusCode'] == 1) {
            this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
            this.deleterExamarray = [];
            this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
            this.getfindingdatabyRgid(this.opdvisitService.patientdetails.pkRegId);
            this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
            document.getElementById("examModal").style.display = "None";
            if (type == 2) {
              this.newlistarrray = [];

            }
            if (this.newlistarrray.length == 0) {
              this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
            }

          } else if (data['statusCode'] == 10) {
            this.dashboardService.openSnackBar("Already exists in the list", "OK");
          } else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        },
          err => {
            this.showspinner = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }

          });
      } else {
        this.showspinner = false;
        if (type == 2) {
          this.newlistarrray = [];
        }
        if (this.newlistarrray.length == 0) {
          this.findings_ds = new MatTableDataSource(this.emrservice.findings.slice());
        }
        this.emrservice.enabledisablebtn = true;
        this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
        document.getElementById("examModal").style.display = "None";
      }
    } else {
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }
  openexamination(): void {
    if (this.emrservice.findingPermission.isAddPermission == true) {
      if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
        const dialogRef = this.dialog.open(ExaminationHelpComponent, {
          panelClass: 'full-width-dialog',
          maxWidth: '75vw',
          width: '75%',
          disableClose: true
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {

          //this.newlistarrray = [];
          if (result.length > 0) {
            this.emrservice.enabledisablebtn = false;
            result?.forEach(item => {
              this.newlistarrray.push({
                pK_TempExamDetailId: item.pK_TempExamDetailId,
                fK_TemplateId: item.fK_TemplateId,
                fk_FindingId: item.fk_FindingId,
                pk_SynchId: item.pk_SynchId,
                findingName: item.findingName,
                examValues1: item.examValues1,
                examValues2: item.examValues2,
                specification: item.findingName,
                findingSubGroup: null,
                isHidden: false,
                isEdit: false
              });
            });
            this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
              if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
                unique.push(o);
              }
              return unique;
            }, []);
            this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
            this.closeAddSlitLampModal();
          }

          console.log('The dialog was closed');
        });
      } else {
        this.dashboardService.openSnackBar("Please Select Visit List", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  opentemplates(): void {
    const dialogRef = this.dialog.open(TemplateFindingsComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '80vw',
      width: '70%',
      disableClose: true
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {
      if (result?.length > 0) {
        this.emrservice.enabledisablebtn = false;
        result?.forEach(element => {
          this.newlistarrray.push({
            pK_TranId: 0,
            fK_VisitId: this.emrservice.visitid,
            fk_FindingId: element.fK_FindingId,
            pk_SynchId: 0,
            findingName: element.findingName,
            examValues1: element.result1,
            examValues2: element.result2,
            specification: element.findingName,
            findingSubGroup: element.findingSubGroup,
            isAllowBlank: element.isAllowBlank,
            isDelete: false,
            isEdit: false
          });

        });
        this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
          if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
      }
    });
  }

  opendocdialog(): void {
    // call dialogue 
    if (this.opdvisitService.patientdetails.pkRegId > 0) {
      const dialogRef = this.dialog.open(PatientdocsComponent, {

        panelClass: 'full-width-dialog',
        maxWidth: '80vw',
        width: '60%',
        data: {
          patID: this.opdvisitService.patientdetails.pkRegId,
          patinit: this.opdvisitService.patientdetails.initial,
          patFname: this.opdvisitService.patientdetails.firstName,
          patLname: this.opdvisitService.patientdetails.lastName
        },
        disableClose: true
      });


      dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {
        console.log('The dialog was closed');
      });
    }


  }

  // open_appointments_dialog(): void {
  //   const dialogRef = this.dialog.open(AppointmentListComponent, {
  //     width: '70%',
  //     disableClose: true,
  //     data: {

  //     }
  //   });

  //   dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {

  //   });
  // }
  opentemplate_help(): void {
    const dialogRef = this.dialog.open(Template_helpComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '95vw',
      width: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: 1
    });


    dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {

      if (result.drRemarks != null) {
        this.opdvisitService.patientDrdetaill[0].drRemarks = result.drRemarks;
      }
      if (result.prognosis != null) {
        this.opdvisitService.patientDrdetaill[0].prognosis = result.prognosis;
      }
      if (result.treatmentPlan != null) {
        this.opdvisitService.patientDrdetaill[0].nextVisitPlan = result.treatmentPlan;
      }
      if (result.diagnosisComments != null) {
        this.opdvisitService.patientDrdetaill[0].diagnosisComments = result.diagnosisComments;
      }
      if (result.type == 0) {
        if (result.examrow.length > 0) {
          this.emrservice.enabledisablebtn = false;
          result.examrow?.forEach(item => {
            this.newlistarrray.push({
              pK_TempExamDetailId: item.pK_TempExamDetailId,
              fK_TemplateId: item.fK_TemplateId,
              fk_FindingId: item.fk_FindingId,
              pk_SynchId: item.pk_SynchId,
              findingName: item.findingName,
              examValues1: item.examValues1,
              examValues2: item.examValues2,
              specification: item.findingName,
              findingSubGroup: null,
              isHidden: false,
              isEdit: false
            });
          });
          this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
            if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
              unique.push(o);
            }
            return unique;
          }, []);
          this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
        }
        if (result.invrow.length > 0) {
          this.emrservice.transferArray.next(result.invrow);
        }
        if (result.medicinerow.length > 0) {
          this.emrservice.transferArrayMedicine.next(result.medicinerow);
        }
        if (result.diagodata.length > 0) {
          this.emrservice.transferArraydiagonsis.next(result.diagodata);
        }
        if (result.surgeryrow.length > 0) {
          this.emrservice.transferArraysurgery.next(result.surgeryrow);
        }
      } else if (result.type == 1) {

        if (Date.parse(this.datepipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
          if (this.authservice.Loggeduser.usertypeid == 6) {
            if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {

              return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
            }
          }

          this.showspinner = true;
          var examinationArray = [];
          var investigationArray = [];
          var mediniceMainArray = [];
          var diagnosisMainArray = [];
          var surgeryMainArray = [];
          if (this.examid == null || this.examid == undefined) {
            this.examid = 0;
          }
          if (result.examrow.length > 0) {
            result.examrow?.forEach(item => {
              examinationArray.push({
                "PK_TranId": 0,
                "FK_ExamId": this.examid ? this.examid : 0,
                "Fk_FindingId": item.fk_FindingId,
                "ExamValues1": item.examValues1,
                "ExamValues2": item.examValues2,
                "Specification": item.findingName,
                "IsDeleted": 0,
                "IsEdit": false
              });

            });

          }
          if (result.invrow.length > 0) {
            result.invrow.forEach((element, index) => {

              investigationArray.push({
                "PK_TranId": 0,
                "FK_ExamId": this.examid ? this.examid : 0,
                "FK_ServiceId": element.fK_ServiceId,
                "Result": '',
                "Eye": '',
                "Academic": '',
                "discount": 0,
                "IsDeleted": 0,
                "IsEdit": false
              });
            });

          }
          if (result.medicinerow.length > 0) {
            result.medicinerow?.forEach(element => {
              mediniceMainArray.push({
                "PK_TranId": 0,
                "FK_ExamId": this.examid ? this.examid : 0,
                "FK_MedicineId": element.fK_MedicineId,
                "Qty": element.qty,
                "unitQty": element.unitQty ? element.unitQty : 0,
                "FK_DosageId": element.fK_DosageId,
                "Days": element.days,
                "Unit": element.unit,
                "Eye": element.site,
                "Remarks": element.remarks,
                "IsDeleted": 0,
                "IsEdit": false
              });

            });
          }
          if (result.diagodata.length > 0) {
            result.diagodata?.forEach(item => {
              diagnosisMainArray.push({
                "PK_TranId": 0,
                "FK_ExamId": this.examid ? this.examid : 0,
                "fK_DiagnosisId": item.fK_DiagnosisId,
                "DiagnosisDate": this.datepipe.transform(this.authservice.localDate, "yyyy-MM-dd"),
                "diagnosisType": '',
                "remarks": item.remarks,
                "OLDExamId": null,
                "IsEdit": false,
                "IsHidden": null,
                "IsDeleted": 0
              });

            });
          }
          if (result.surgeryrow.length > 0) {
            result.surgeryrow.forEach(itemdata => {
              surgeryMainArray.push({
                "PK_TranId": 0,
                "FK_ExamId": this.examid ? this.examid : 0,
                "FK_SurgeryId": itemdata.fK_surgeryId,
                "FK_QualifierId": 0,
                "FK_SurgeonId": this.opdvisitService.DoctorIdEmr ? this.opdvisitService.DoctorIdEmr : 0,
                "Remarks": itemdata.remarks ? itemdata.remarks : 'None',
                "IsDeleted": 0,
                "IsEdit": false
              });

            })

            surgeryMainArray = surgeryMainArray.reduce((unique, o) => {
              if (!unique.some(obj => obj.fK_SurgeryId === o.fK_SurgeryId)) {
                unique.push(o);
              }
              return unique;
            }, []);

          }

          this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid ? this.examid : 0,
            this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
          this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
          this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
          this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;

          let payloadarray = {

            DrExam: {
              ...this.opdvisitService.patientDrdetaill[0]

            },

            DrFinding: examinationArray
            ,
            DrDiag: diagnosisMainArray,
            DrPrescrip: mediniceMainArray,
            DrInvest: investigationArray
            , DrSurgery: surgeryMainArray
          }
          this.emrservice.SaveDrwrokupData(payloadarray).pipe(takeUntil(this.destroyfinding$)).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.examid = data['id'];
              this.emrservice.examid = data['id'];
              this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 0);
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
              this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0)
            } else if (data['statusCode'] == 10) {
              this.dashboardService.openSnackBar("Already exists in the list", "OK");
            }
            setTimeout(() => {
              this.showspinner = false;
            }, 1000)
          }, err => {
            this.showspinner = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        }
      } else {
        this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
      }
    });
  }

  opendesign_workup(): void {
    const dialogRef = this.dialog.open(Image_workupComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '90vw',
      width: '90%',
      height: '90%',
      disableClose: true,
      data: {
        "Doctorid": this.opdvisitService.DoctorIdEmr,
        "visitid": this.emrservice.visitid,
        "folderName": 'OPDWorkup'
      }
    });


    dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {
      console.log('The dialog was closed');

    });
  }

  opd_settinng(): void {
    this.emrservice.localStorePriscription = [];
    const dialogRef = this.dialog.open(OpdSettingComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '80vw',
      width: '50%',
      disableClose: true,
      data: this.PrintList
    });


    dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {

      if (result != undefined) {
        if (result.length > 0) {
          this.PrintList = [];
          this.emrservice.localStorePriscription = result;
          this.PrintList = result;
        }
      }

    });

  }

  old_Case(): void {
    const dialogRef = this.dialog.open(OldcaseComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '70vw',
      width: '50%',
      height:'57%',
      disableClose: true
    });


    dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  getsummary_url(patientid: number, type: number) {
    if (this.opdvisitService.patientdetails.pkRegId) {
      if (type == 0) {
        let checkreporttype = this.authservice.webreportConfig.filter(item => item.printOption == 'Medical Record' && item.printType == 'NetramReport');
        if (checkreporttype.length > 0) {
          this.dashboardService.getsummary_url().pipe(takeUntil(this.destroyfinding$)).subscribe(
            data => this.succesurl(data, patientid, type), err => this.failedurl(err)
          )
        } else {
          this.showspinner = true;
          this.printTimelineBill(1);
        }
      } else {
        this.dashboardService.getsummary_url().pipe(takeUntil(this.destroyfinding$)).subscribe(
          data => this.succesurl(data, patientid, type), err => this.failedurl(err)
        )
      }

    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  succesurl(data, patientid, type) {

    const urldate = data.filter(item => item.propertyName == 'WebURL');
    const url = urldate[0].propertyValue;
    if (type == 0) {
      var newWindow = window.open(url + 'PatientEMRSummary.aspx?RegID=' + patientid + '&BillCompanyName=' + this.authservice.Loggeduser.billingcompanyname + '&VisitOrderType=DESC' + '&BranchId=' + this.authservice.Loggeduser.branchid);
    } else if (type == 1) {
      var newWindow = window.open(url + 'ImageSummary.aspx?RegID=' + patientid);
    }


  }
  failedurl(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  Cancelpopup(type) {
    if (type == 1) {
      if (this.emrservice.findingPermission.isDeletePermission == true) {
        document.getElementById("examModal").style.display = "Block";
      } else {
        this.dashboardService.openSnackBar("Delete permission denied", "ok");
      }
    } else {
      document.getElementById("examModal").style.display = "None";
    }

  }
  drfindingdata: any = [];
  saveExaminationFinding(type: any) {
    if (Date.parse(this.datepipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid == 9) {
      if (this.authservice.Loggeduser.usertypeid == 6) {
        if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
          this.showspinner = false;
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      this.drfindingdata = [];
      if (this.emrservice.findingPermission.isAddPermission == true) {
        if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
          if (this.examid == null || this.examid == undefined) {
            this.examid = 0;
          }
          if (this.opdvisitService.patientdetails.pkRegId) {
            if (this.findings_ds.data.length > 0) {
              if (this.findings_ds.data[0].examValues1 == '' && this.findings_ds.data[0].examValues2 == ''
                && this.findings_ds.data[0].findingName == '') {
                this.dashboardService.openSnackBar("Please Select Examination", "OK");
              } else {

                if (type == 0) {
                  this.showspinner = true;
                }
                //   const filteredData = this.findings_ds.data.filter(item => {
                //   return (item.examValues1 && item.examValues1.trim() !== '') || (item.examValues2 && item.examValues2.trim() !== '');
                // });

                this.findings_ds.data.forEach(item => {
                  const isBlankAllowed = item.isAllowBlank === true;
                  const isExamValue1Empty = item.examValues1 == null || item.examValues1 === '';
                  const isExamValue2Empty = item.examValues2 == null || item.examValues2 === '';

                  if (isBlankAllowed && isExamValue1Empty && isExamValue2Empty) {
                    return; 
                  }

                  this.drfindingdata.push({
                    PK_TranId: item.pK_TranId ?? 0,
                    FK_ExamId: this.examid,
                    Fk_FindingId: item.fk_FindingId,
                    ExamValues1: item.examValues1,
                    ExamValues2: item.examValues2,
                    Specification: item.specification,
                    IsDeleted: 0,
                    isEdit: !!item.pK_TranId,
                  });
                });
                if (this.deleterExamarray.length > 0) {
                  var cnewdata = [];
                  cnewdata = this.deleterExamarray;
                  cnewdata = cnewdata.concat(this.drfindingdata);
                  this.drfindingdata = cnewdata;
                }
                this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
                this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
                this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
                this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
                this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
                let payload = {
                  DrExam: {
                    ...this.opdvisitService.patientDrdetaill[0]

                  },

                  DrFinding: this.drfindingdata
                  ,
                  DrDiag: [
                  ],
                  DrPrescrip: [
                  ],
                  DrInvest: [
                  ]
                  , DrSurgery: [
                  ]
                }
                cnewdata = null;
                this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroyfinding$)).subscribe(data => {
                  this.showspinner = false;
                  this.deleterExamarray = [];
                  if (this.examid > 0) {
                    this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
                  } else {
                    this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
                  }
                  if (data['statusCode'] == 1) {
                    this.examid = data['id'];
                    this.emrservice.examid = data['id'];
                    //  this.emrservice.content.next('2');
                    this.emrservice.enabledisablebtn = true;
                    this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
                    this.getfindingdatabyRgid(this.opdvisitService.patientdetails.pkRegId);

                    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");

                    this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0)
                  } else if (data['statusCode'] == 10) {
                    this.dashboardService.openSnackBar("Already exists in the list", "OK");
                  } else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                },
                  err => {
                    this.showspinner = false;
                    if (err.status == 403) {
                      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                    }
                    else if (err.error.statusCode == 422) {
                      this.dashboardService.openSnackBar(err.error.message, "OK");
                    }
                    else {
                      this.dashboardService.openSnackBar("API Failed", "OK");
                    }

                  });

              }
            } else {
              this.showspinner = false;
              this.dashboardService.openSnackBar("Please Select Examination", "OK");
            }
          } else {
            this.dashboardService.openSnackBar("Please Select Patient", "OK");
          }

        } else {
          this.dashboardService.openSnackBar("Please Select Visit List", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Add permission denied", "ok");
      }
    } else {
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "ok");
    }
  }


  getpreSetting(bachid, userid, data) {
    this.showspinner = true;
    if (this.emrservice.localStorePriscription.length == 0) {
      this.emrservice.GetPreSetting(bachid, userid, data).pipe(takeUntil(this.destroyfinding$)).subscribe(item => {
        this.prescriptionSetting = [];
        this.PrintList = [];
        this.prescriptionSetting = item;

        this.PrintList = this.prescriptionSetting.filter(x => !x.colName.startsWith("Clear"));
        if (this.prescriptionSetting.length == 0) {
          this.defualtsetdata(data);
        } else {
          let checkreporttype = this.authservice.webreportConfig.filter(item => item.printOption == 'Prescription' && item.printType == 'NetramReport');
          if (checkreporttype.length > 0) {
            this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
          } else {
            this.printTimelineBill(0)
          }

        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.PrintList = [];
      this.PrintList = this.emrservice.localStorePriscription;
      let checkreporttype = this.authservice.webreportConfig.filter(item => item.printOption == 'Prescription' && item.printType == 'NetramReport');
      if (checkreporttype.length > 0) {
        this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
      } else {
        this.printTimelineBill(0)
      }
    }



  }

  defualtsetdata(data) {
    this.emrservice.GetPreSetting(1, 1, data).pipe(takeUntil(this.destroyfinding$)).subscribe(item => {
      this.prescriptionSetting = [];
      this.PrintList = [];
      this.prescriptionSetting = item;
      this.PrintList = this.prescriptionSetting.filter(x => !x.colName.startsWith("Clear"));
      let checkreporttype = this.authservice.webreportConfig.filter(item => item.printOption == 'Prescription' && item.printType == 'NetramReport');
      if (checkreporttype.length > 0) {
        this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
      } else {
        this.printTimelineBill(0)
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  printTimelineBill(type) {

    let payload = {
      "WebReportPrintMaster": {
        "module": "Doctor",
        // "printOption": "Prescription",
        "printOption": type == 0 ? "Prescription" : "Medical Record",
        "printType": "WebNetramReport",
        "PRINTDATE": this.datepipe.transform(this.authservice.localDate, "dd-MM-yyyy"),
        "PrintTime": this.emrservice.convertTime12Hour(new Date()),
        "Pk_RegId": this.opdvisitService.patientdetails.pkRegId,
        "BILLINGCOMPANYNAME": this.authservice.Loggeduser.billingcompanyname,
        "PRINTCONFIGURATIONARRAY": JSON.stringify(this.PrintList),
        "Pk_VisitId": this.emrservice.visitid,
        "Pk_ExamId": type == 0 ? this.emrservice.examid : 0,
        "VISITDATE": this.datepipe.transform(this.emrservice.visitDate, "dd-MM-yyyy"),
        "LINE1": this.emrservice.branchmansterObj.line1,
        "LINE2": this.emrservice.branchmansterObj.line2,
        "LINE3": this.emrservice.branchmansterObj.line3,
        "LINE4": this.emrservice.branchmansterObj.line4,
        "HOSPITALIMAGE": "../../../" + this.authservice.loginclientlogo,
        "COMPANYIMAGE": "../../../" + this.authservice.leftbottomlogosm,
        "CERTIFICATE1IMAGE": "../../../" + this.authservice.nabhlogo,
        "CERTIFICATE2COMPANYIMAGE": '',
        "PrintHeaderArray": 'Y',
        "PatientRegistrationArray": 'Y',
        "VisitMasterArray": 'Y',
        'HistoryGeneralArray': 'Y',
        'DoctorExaminationMasterArray': 'Y',
        'AutoRefExaminationArray': 'Y',
        'HistoryDiseaseArray': 'Y',
        "CounselorExaminationArray": type == 1 ? 'Y' : 'N',
        "HistorySurgicalArray": 'Y',
        "HistoryFamilyArray": 'Y',
        "HistoryDrugAllergyArray": 'Y',
        "PresentingComplaintsArray": 'Y',
        "AdvisedInvestigationsArray": 'Y',
        "IntraocularPressureArray": 'Y',
        "OptoExaminationArray": 'Y',
        "OptoTestDetailArray": 'Y',
        "OptoSlitLampExaminationArray": 'Y',
        "CurrentMedicationDetailArray": 'Y',
        "DoctorFindingArray": 'Y',
        "DoctorInvestigationArray": 'Y',
        "DoctorDiagnosisArray": 'Y',
        "DoctorPrescriptionArray": 'Y',
        "DoctorSurgeryArray": 'Y',

      }
    }
    this.emrservice.GetWebReportPrint(payload).pipe(takeUntil(this.destroyfinding$)).subscribe((x: any) => {
      this.showspinner = false;
      if (x.length > 0) {
        let printContents, popupWin;

        printContents = x[0].printTemplate;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

        popupWin.document.open();
        popupWin.document.write(`
  <html>
   
  <body onload="window.print()">${printContents}
  </body>
  </html>`
        );

        popupWin.document.close();
      } else {
        this.dashboardService.openSnackBar("Report Template Not Set", "OK");
      }
    }, err => {
      this.showspinner = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })

  }
  getprintReport_url(patientid: number) {
    if (this.opdvisitService.patientdetails.pkRegId) {
      this.dashboardService.getsummary_url().pipe(takeUntil(this.destroyfinding$)).subscribe(
        data =>

          this.succesurldata(data, patientid), err => this.failedurldata(err)
      )

    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }


  succesurldata(data, patientid) {
    this.showspinner = false;
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      if (element.propertyName === "PrescriptionMedicinePattern") {
        this.PrescriptionMedicine = element;
      }

      if (element.propertyName === "PageHeadWebReport") {
        this.PageHeader = element;
      }

      if (element.propertyName === "WebURL") {
        this.reporturl = element.propertyValue;
      }

    }

    this.Visitdate = this.emrservice.visitDate;
    let vDate = this.datepipe.transform(this.Visitdate, 'dd-MMM-yyyy');
    var newWindow = window.open(this.reporturl + 'Prescription.aspx?PrescriptionMedicinePattern=' + this.PrescriptionMedicine.propertyValue + '&BranchId=' + this.authservice.Loggeduser.branchid + '&BillCompanyName=' + this.authservice.Loggeduser.billingcompanyname + '&RegID=' + patientid + '&AgeDesc=' + this.opdvisitService.printpriciptionAge + '&VisitID=' + this.emrservice.visitid + '&VisitDate=' + vDate + '&ExamID=' + this.examid + '&DoctorId=' + this.opdvisitService.DoctorIdEmr + '&' + this.PrintList[0].colName + '=' + (this.PrintList[0].colValue == true ? 'Y' : 'N') +
      '&PageHeadWebReport=' + (this.PrintList[13].colValue == true ? 'Y' : 'N') +
      '&PrintOPDTest=' + (this.PrintList[15].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[1].colName + '=' + (this.PrintList[1].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[2].colName + '=' + (this.PrintList[2].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[3].colName + '=' + (this.PrintList[3].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[4].colName + '=' + (this.PrintList[4].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[5].colName + '=' + (this.PrintList[5].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[6].colName + '=' + (this.PrintList[6].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[7].colName + '=' + (this.PrintList[7].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[8].colName + '=' + (this.PrintList[8].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[9].colName + '=' + (this.PrintList[9].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[10].colName + '=' + (this.PrintList[10].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[11].colName + '=' + (this.PrintList[11].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[12].colName + '=' + (this.PrintList[12].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[13].colName + '=' + (this.PrintList[13].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[14].colName + '=' + (this.PrintList[14].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[15].colName + '=' + (this.PrintList[15].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[16].colName + '=' + (this.PrintList[16].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[17].colName + '=' + (this.PrintList[17].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[18].colName + '=' + (this.PrintList[18].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[19].colName + '=' + (this.PrintList[19].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[20].colName + '=' + (this.PrintList[20].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[21].colName + '=' + (this.PrintList[21].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[22].colName + '=' + (this.PrintList[22].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[23].colName + '=' + (this.PrintList[23].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[24].colName + '=' + (this.PrintList[24].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[25].colName + '=' + (this.PrintList[25].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[26].colName + '=' + (this.PrintList[26].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[27].colName + '=' + (this.PrintList[27].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[28].colName + '=' + (this.PrintList[28].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[29].colName + '=' + (this.PrintList[29].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[30].colName + '=' + (this.PrintList[30].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[31].colName + '=' + (this.PrintList[31].colValue == true ? 'Y' : 'N') +
      '&' + this.PrintList[32].colName + '=' + (this.PrintList[32].colValue == true ? 'Y' : 'N') +
      '&UserTypeId=' + this.authservice.Loggeduser.usertypeid + '&LanguageId=' + 1 + '&ReportHeading=Prescription');
  }
  failedurldata(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  refReasonPOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        typeid: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyfinding$)).subscribe(result => {
      if (result != 0) {
        this.opdvisitService.patientDrdetaill[0].examinationComments = result;

      }
      this.emrservice.enabledisablebtn = false;
    });
  }


  // updateEdit(): void {

  //   this.findings_ds.data.forEach((item, index) => {
  //     const id = index;
  //     this.editCache[id] = {
  //       edit: false,
  //       data: { ...item }
  //     };
  //   });

  // }

  // updateEdit(): void {
  //   // Go through whatever DataSource is holding your rows
  //   this.findings_ds.data.forEach((item, index) => {
  //     // Convert the comma-separated string into arrays
  //     const rightEyeArray = (item.examValues1 || '')
  //       .split(',')
  //       .map(s => s.trim())
  //       .filter(Boolean);

  //     const leftEyeArray = (item.examValues2 || '')
  //       .split(',')
  //       .map(s => s.trim())
  //       .filter(Boolean);

  //     const bothEyeArray = (item.BE || '')
  //       .split(',')
  //       .map(s => s.trim())
  //       .filter(Boolean);

  //     // Create FormControls for each
  //     const rightEyeCtrl = new FormControl();
  //     const leftEyeCtrl  = new FormControl();
  //     const bothEyeCtrl  = new FormControl();

  //     // Tie them to filtered Observables so that they show checkboxes in the dropdown
  //     const filteredRightOptions: Observable<any[]> = rightEyeCtrl.valueChanges.pipe(
  //       startWith(null),
  //       map((typedValue: string | null) => {
  //         if (!typedValue) {
  //           return this.result_ds; // or however you store the available results
  //         }
  //         const filterValue = typedValue.toLowerCase();
  //         return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
  //       })
  //     );

  //     const filteredLeftOptions: Observable<any[]> = leftEyeCtrl.valueChanges.pipe(
  //       startWith(null),
  //       map((typedValue: string | null) => {
  //         if (!typedValue) {
  //           return this.result_ds;
  //         }
  //         const filterValue = typedValue.toLowerCase();
  //         return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
  //       })
  //     );

  //     const filteredBothOptions: Observable<any[]> = bothEyeCtrl.valueChanges.pipe(
  //       startWith(null),
  //       map((typedValue: string | null) => {
  //         if (!typedValue) {
  //           return this.result_ds;
  //         }
  //         const filterValue = typedValue.toLowerCase();
  //         return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
  //       })
  //     );

  //     // Finally, set up editCache for that row
  //     this.editCache[index] = {
  //       edit: false,
  //       data: {
  //         ...item,

  //         // Arrays of selected chips
  //         rightEyeArray,
  //         leftEyeArray,
  //         bothEyeArray,

  //         // The new FormControls
  //         rightEyeCtrl,
  //         leftEyeCtrl,
  //         bothEyeCtrl,

  //         // The new Observables for checkboxes + autocomplete
  //         filteredRightOptions,
  //         filteredLeftOptions,
  //         filteredBothOptions,
  //       }
  //     };
  //   });
  // }


  updateEdit(): void {
    this.findings_ds.data.forEach((item, index) => {
      const rightEyeArray = (item.examValues1 || '').split(',').map(s => s.trim()).filter(Boolean);
      const leftEyeArray = (item.examValues2 || '').split(',').map(s => s.trim()).filter(Boolean);
      const bothEyeArray = (item.BE || '').split(',').map(s => s.trim()).filter(Boolean);

      const rightEyeCtrl = new FormControl();
      const leftEyeCtrl = new FormControl();
      const bothEyeCtrl = new FormControl();

      const filteredRightOptions: Observable<any[]> = rightEyeCtrl.valueChanges.pipe(
        startWith(null),
        map(typedValue => {
          if (!typedValue) {
            return this.result_ds;
          }
          const filterValue = typedValue.toLowerCase();
          return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
        })
      );

      const filteredLeftOptions: Observable<any[]> = leftEyeCtrl.valueChanges.pipe(
        startWith(null),
        map(typedValue => {
          if (!typedValue) {
            return this.result_ds;
          }
          const filterValue = typedValue.toLowerCase();
          return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
        })
      );

      const filteredBothOptions: Observable<any[]> = bothEyeCtrl.valueChanges.pipe(
        startWith(null),
        map(typedValue => {
          if (!typedValue) {
            return this.result_ds;
          }
          const filterValue = typedValue.toLowerCase();
          return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
        })
      );

      this.editCache[index] = {
        edit: false,
        originalData: { ...item },
        data: {
          ...item,
          rightEyeArray,
          leftEyeArray,
          bothEyeArray,
          rightEyeCtrl,
          leftEyeCtrl,
          bothEyeCtrl,
          filteredRightOptions,
          filteredLeftOptions,
          filteredBothOptions
        }
      };
    });
  }

  onRightChipAdd(event: any, rowIndex: number): void {
    if (this.rightEyeTrigger && this.rightEyeTrigger.panelOpen) {
      return;
    }
    const inputValue = (event.value || '').trim();
    if (!inputValue) {
      return;
    }
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    if (!rightArray.includes(inputValue)) {
      rightArray.push(inputValue);
    }
    event.input.value = '';
    this.editCache[rowIndex].data.rightEyeCtrl.setValue(null);
    this.findings_ds.data[rowIndex].examValues1 = rightArray.join(', ');
  }

  onRightSelect(event: MatAutocompleteSelectedEvent, rowIndex: number): void {
    const newVal = event.option.value || '';
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    if (rightArray.includes(newVal)) {
      rightArray.splice(rightArray.indexOf(newVal), 1);
    } else {
      rightArray.push(newVal);
    }
    this.editCache[rowIndex].data.rightEyeCtrl.setValue('');
    if (this.rightEyeInput) {
      this.rightEyeInput.nativeElement.value = '';
    }
    this.findings_ds.data[rowIndex].examValues1 = rightArray.join(', ');
    requestAnimationFrame(() => {
      this.openAuto(this.rightEyeTrigger);
    });
  }

  onRemoveRightChip(rowIndex: number, chipIndex: number): void {
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    rightArray.splice(chipIndex, 1);
    this.findings_ds.data[rowIndex].examValues1 = rightArray.join(', ');
  }

  onLeftChipAdd(event: any, rowIndex: number): void {
    if (this.leftEyeTrigger && this.leftEyeTrigger.panelOpen) {
      return;
    }
    const inputValue = (event.value || '').trim();
    if (!inputValue) {
      return;
    }
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;
    if (!leftArray.includes(inputValue)) {
      leftArray.push(inputValue);
    }
    event.input.value = '';
    this.editCache[rowIndex].data.leftEyeCtrl.setValue(null);
    this.findings_ds.data[rowIndex].examValues2 = leftArray.join(', ');
  }

  onLeftSelect(event: MatAutocompleteSelectedEvent, rowIndex: number): void {
    const newVal = event.option.value || '';
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;
    if (leftArray.includes(newVal)) {
      leftArray.splice(leftArray.indexOf(newVal), 1);
    } else {
      leftArray.push(newVal);
    }
    this.editCache[rowIndex].data.leftEyeCtrl.setValue('');
    if (this.leftEyeInput) {
      this.leftEyeInput.nativeElement.value = '';
    }
    this.findings_ds.data[rowIndex].examValues2 = leftArray.join(', ');
    requestAnimationFrame(() => {
      this.openAuto(this.leftEyeTrigger);
    });
  }

  onRemoveLeftChip(rowIndex: number, chipIndex: number): void {
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;
    leftArray.splice(chipIndex, 1);
    this.findings_ds.data[rowIndex].examValues2 = leftArray.join(', ');
  }

  onBothChipAdd(event: any, rowIndex: number): void {
    if (this.bothEyeTrigger && this.bothEyeTrigger.panelOpen) {
      return;
    }
    const inputValue = (event.value || '').trim();
    if (!inputValue) {
      return;
    }
    const bothArray = this.editCache[rowIndex].data.bothEyeArray;
    if (!bothArray.includes(inputValue)) {
      bothArray.push(inputValue);
    }
    event.input.value = '';
    this.editCache[rowIndex].data.bothEyeCtrl.setValue(null);

    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;

    if (!rightArray.includes(inputValue)) {
      rightArray.push(inputValue);
    }
    if (!leftArray.includes(inputValue)) {
      leftArray.push(inputValue);
    }

    this.findings_ds.data[rowIndex].BE = bothArray.join(', ');
    this.findings_ds.data[rowIndex].examValues1 = rightArray.join(', ');
    this.findings_ds.data[rowIndex].examValues2 = leftArray.join(', ');
  }


  onBothSelect(event: MatAutocompleteSelectedEvent, rowIndex: number): void {
    const newVal = event.option.value || '';
    const bothArray = this.editCache[rowIndex].data.bothEyeArray;

    if (bothArray.includes(newVal)) {
      bothArray.splice(bothArray.indexOf(newVal), 1);
    } else {
      bothArray.push(newVal);
    }
    this.editCache[rowIndex].data.bothEyeCtrl.setValue('');
    if (this.bothEyeInput) {
      this.bothEyeInput.nativeElement.value = '';
    }

    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;

    if (bothArray.includes(newVal)) {
      if (!rightArray.includes(newVal)) {
        rightArray.push(newVal);
      }
      if (!leftArray.includes(newVal)) {
        leftArray.push(newVal);
      }
    } else {
      const ixR = rightArray.indexOf(newVal);
      if (ixR >= 0) rightArray.splice(ixR, 1);

      const ixL = leftArray.indexOf(newVal);
      if (ixL >= 0) leftArray.splice(ixL, 1);
    }

    this.findings_ds.data[rowIndex].BE = bothArray.join(', ');
    this.findings_ds.data[rowIndex].examValues1 = rightArray.join(', ');
    this.findings_ds.data[rowIndex].examValues2 = leftArray.join(', ');

    requestAnimationFrame(() => {
      this.openAuto(this.bothEyeTrigger);
    });
  }


  onRemoveBothChip(rowIndex: number, chipIndex: number): void {
    const bothArray = this.editCache[rowIndex].data.bothEyeArray;
    const removedVal = bothArray[chipIndex];
    bothArray.splice(chipIndex, 1);
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;

    const ixR = rightArray.indexOf(removedVal);
    if (ixR >= 0) rightArray.splice(ixR, 1);

    const ixL = leftArray.indexOf(removedVal);
    if (ixL >= 0) leftArray.splice(ixL, 1);
    this.findings_ds.data[rowIndex].BE = bothArray.join(', ');
    this.findings_ds.data[rowIndex].examValues1 = rightArray.join(', ');
    this.findings_ds.data[rowIndex].examValues2 = leftArray.join(', ');
  }




  openAuto(trigger: MatAutocompleteTrigger) {
    if (trigger) {
      trigger.openPanel();
    }
  }
  Edit(index, ele: any) {

    if (this.emrservice.findingPermission?.isModifyPermission == true) {
      this.result_ds = this.resultArray.filter(item => item.fk_FindingId == ele.fk_FindingId);
      this.rightTypeControlledit();
      this.leftTypeControlledit();
      this.bothTypeControlledit();
      const id = index;
      this.findId = id;
      this.updateEdit();
      this.editCache[id].edit = true;
      this.findings_ds.data[index].isEdit = true;
      this.emrservice.enabledisablebtn = false;

    } else {
      this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
  }

  editfindingdata: any = [];
  // saveEdit(idx: number): void {
  //   const editlist = this.editCache[idx].data;

  //   // 1) Update your newlistarrray row
  //   this.newlistarrray[idx].examValues1 = editlist.examValues1;
  //   this.newlistarrray[idx].examValues2 = editlist.examValues2;
  //   this.newlistarrray[idx].BE         = editlist.BE;
  //   this.newlistarrray[idx].findingName = editlist.findingName;

  //   // 2) Also update the row in findings_ds
  //   this.findings_ds.data[idx].examValues1 = editlist.examValues1;
  //   this.findings_ds.data[idx].examValues2 = editlist.examValues2;
  //   this.findings_ds.data[idx].BE          = editlist.BE;
  //   this.findings_ds.data[idx].findingName = editlist.findingName;

  //   // 3) Force table to see changes
  //   this.findings_ds.data = [...this.findings_ds.data];

  //   // 4) Exit edit mode
  //   this.editCache[idx].edit = false;

  //   // 5) Optionally call your API
  //   this.saveExaminationFinding(0);
  // }


  // saveEdit(idx: number): void {
  //   const editRow = this.editCache[idx].data;

  //   // Arrays → comma strings
  //   const rightString = (editRow.rightEyeArray || []).join(', ');
  //   const leftString  = (editRow.leftEyeArray  || []).join(', ');
  //   const bothString  = (editRow.bothEyeArray  || []).join(', ');

  //   // Update main array
  //   this.newlistarrray[idx].examValues1   = rightString;
  //   this.newlistarrray[idx].examValues2   = leftString;
  //   this.newlistarrray[idx].BE            = bothString;
  //   this.newlistarrray[idx].specification = editRow.findingName; 
  //   // or this.newlistarrray[idx].findingName = editRow.findingName; 
  //   // if you prefer

  //   // Update table array
  //   this.findings_ds.data[idx].examValues1   = rightString;
  //   this.findings_ds.data[idx].examValues2   = leftString;
  //   this.findings_ds.data[idx].BE            = bothString;
  //   this.findings_ds.data[idx].specification = editRow.findingName; 

  //   // Re-render & exit edit mode
  //   this.findings_ds.data = [...this.findings_ds.data];
  //   this.editCache[idx].edit = false;

  //   // Now do final save
  //   this.saveExaminationFinding(0);
  // }



  saveEdit(idx: number): void {
    const editRow = this.editCache[idx].data;
    const rightString = (editRow.rightEyeArray || []).join(', ');
    const leftString = (editRow.leftEyeArray || []).join(', ');
    const bothString = (editRow.bothEyeArray || []).join(', ');

    this.findings_ds.data[idx].examValues1 = rightString;
    this.findings_ds.data[idx].examValues2 = leftString;
    this.findings_ds.data[idx].BE = bothString;
    this.findings_ds.data[idx].specification = editRow.findingName;

    this.findings_ds.data = [...this.findings_ds.data];

    this.editCache[idx].originalData = { ...this.findings_ds.data[idx] };

    this.editCache[idx].edit = false;
    this.saveExaminationFinding(0);
  }



  cancelEdit(idx: number): void {
    const original = this.editCache[idx].originalData;
    this.findings_ds.data[idx] = { ...original };

    this.findings_ds.data = [...this.findings_ds.data];

    this.editCache[idx].edit = false;
  }


  getenable(event: any) {
    if (event != null) {
      this.emrservice.enabledisablebtn = false;
    }

  }
  getNormalFinding() {
    this.emrservice.GetNormalFindingTemplate(1).pipe(takeUntil(this.destroyfinding$)).subscribe((x: any) => {
      if (x.length > 0) {
        this.emrservice.enabledisablebtn = false;
        x.forEach(element => {
          this.newlistarrray.push({
            pK_TranId: 0,
            fK_VisitId: this.emrservice.visitid,
            fk_FindingId: element.fK_FindingId,
            pk_SynchId: 0,
            findingName: element.findingName,
            examValues1: element.result1,
            examValues2: element.result2,
            specification: element.findingName,
            findingSubGroup: element.findingSubGroup,
            isDelete: false,
            isEdit: false
          });

        });
        this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
          if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  cameraList: MediaDeviceInfo[] = [];
  captures: any = [];
  selectedCameraId: string = '';
  closecamera: any;
  camvisitid: any = null;
  camexamid: any = null;
  description: any = null;
  //Slit Lamp Modal
  selectedrow: number = -1;
  imageviewertype: number = 1;
  saveimageobject: webCamModel = {};
  imagearrayshowing: any = [];
  showspinner1: boolean = false;
  slitLampOpenModal() {
    if (this.emrservice.examid != null && this.emrservice.examid != undefined) {
      this.actvateeye = 'RE';
      this.camvisitid = this.emrservice.visitid;
      this.camexamid = this.emrservice.examid;
      this.emrservice
        .getCareVisit(
          0,
          0
        )
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (x: any) => {

            this.opdvisitService.visitdates = x.sort((a, b) => {
              return (
                <any>new Date(b.visitDate) - <any>new Date(a.visitDate) ||
                <any>b.pK_ExamId - <any>a.pK_ExamId
              );
            });
            this.selectedrow = 0;
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
              this.emrservice.getCameraList().then((cameras) => {
                this.cameraList = cameras;
                this.selectedCameraId = this.cameraList[0]?.deviceId;
                navigator.mediaDevices
                  .getUserMedia({ video: { deviceId: this.selectedCameraId } })
                  .then((localMediaStream) => {
                    const video = document.getElementById('videoElement') as HTMLVideoElement;
                    this.closecamera = localMediaStream;
                    video.srcObject = localMediaStream;
                  })
                  .catch((error) => {
                    console.log("Rejected!", error);
                  });
              }).catch(err => {
                console.error('Error accessing cameras:', err);
              });


            }
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          })
      //Take Photo Modal

      //get camera list 

      document.getElementById("slitLampModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please save the DR workup before opening the slit lamp.", "ok")
    }

  }

  captureImages(eyetype: any) {
    if (this.camexamid > 0) {
      const checkdate = this.opdvisitService.visitdates.filter(x => x.pK_ExamId == this.camexamid)[0]?.visitDate;
      if (Date.parse(this.datepipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(checkdate, "yyyy-MM-dd").toString())) {
        if (this.authservice.Loggeduser.usertypeid == 6) {
          if (this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {

            return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
          }
        }
        const videoElement = document.getElementById('videoElement') as HTMLVideoElement;
        const canvasElement = document.getElementById('canvasElement') as HTMLCanvasElement;
        // const capturedImage = document.getElementById('capturedImage') as HTMLImageElement;
        const context = canvasElement.getContext('2d');
        if (context) {
          context.drawImage(videoElement, 0, 0, 640, 480);
          const imageUrl = canvasElement.toDataURL('image/jpeg');
          const rndInt = Math.floor(Math.random() * 16) + 5;
          const imagename = eyetype + '_' + this.camexamid + '_' + rndInt + '.JPEG';
          const filedata = this.base64toBlob(imageUrl, imagename);
          let payload = {
            pK_TranID: 0,
            file: filedata,
            imageLink: imageUrl,
            imageName: filedata.name,
            eye: eyetype,
            fK_ExamID: this.camexamid,
            description: this.description,
            isEdit: false

          }
          // this.captures.push(payload);
          this.saveimageobject = payload;
          this.saveimageData(0);
        }
      } else {
        this.dashboardService.openSnackBar("Cature Image allowed only today's visit date.", "ok")
      }
    } else {
      this.dashboardService.openSnackBar("Please complete the DR workup before capturing the images.", "ok")
    }
  }
  base64toBlob(base64, filename, format = 'JPEG') {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: format });
  }
  descriptiondata(value) {
    this.description = value;
  }
  returncount(caparray: any) {
    if (caparray.length > 0) {
      return caparray.filter(item => item.eye == this.actvateeye).length;
    } else {
      return 0
    }

  }
  eyeChangeMethod(event) {
    this.viewimagedata = this.captures.filter(item => item.eye == event.value);
    this.imagearrayshowing = [];
    this.imageviewertype = 1;
    if (this.viewimagedata.length > 0) {
      this.get_old_photo(this.viewimagedata[0].fK_ExamID, this.viewimagedata[0].imageName);
      this.viewimagedata.map(item => item.ischecked = false);
      this.viewimagedata[0].ischecked = true;
    }
  }
  previousScreen() {
    this.enablebtnSection = false;
  }
  actvateeye: any = null
  activateEyeType(eyetype) {
    this.description = null;
    this.actvateeye = eyetype;
    var vid = 'videoElement';

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((localMediaStream) => {
          const video = document.getElementById(vid) as HTMLVideoElement;
          this.closecamera = localMediaStream;
          video.srcObject = localMediaStream;
        })
        .catch((error) => {
          console.log("Rejected!", error);
        });

    }
  }
  selectrow(row, index: any) {
    if (row.pK_ExamId > 0) {
      this.selectedrow = index;
      this.camvisitid = row.fK_VisitId;
      this.camexamid = row.pK_ExamId;
      this.ImageViewer(1);
    } else {
      this.dashboardService.openSnackBar("Please complete the DR workup before capturing the images.", "ok")
    }

  }
  closeSlitLampModal() {

    if (this.closecamera != undefined) {
      this.closecamera.getTracks().forEach(function (track) {
        if (track.readyState == 'live') {
          track.stop();
        }
      });

    }
    this.captures = [];
    this.enablebtnSection = false;
    this.selectedrow = -1;
    this.camvisitid = null;
    this.camexamid = null;
    this.description = null;
    this.actvateeye = null;
    this.imageviewertype = null;
    this.viewimagedata = [];
    this.imagearrayshowing = [];
    this.saveimageobject = {};
    this.showspinner1 = false;
    document.getElementById("slitLampModal").style.display = "none";
  }
  imageGrid(type) {
    this.imageviewertype = type;
  }
  selectCamera(event) {

    this.selectedCameraId = event.value;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {

      navigator.mediaDevices
        .getUserMedia({ video: { deviceId: this.selectedCameraId } })
        .then((localMediaStream) => {
          const video = document.getElementById('videoElement') as HTMLVideoElement;
          this.closecamera = localMediaStream;
          video.srcObject = localMediaStream;
        })
        .catch((error) => {
          console.log("Rejected!", error);
        });

    }
  }
  //Add Slit Lamp Modal
  addSlitLampModal() {
    if (this.emrservice.findingPermission.isAddPermission == true) {
      document.getElementById("addSlitLampModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "ok")
    }
  }
  closeAddSlitLampModal() {
    document.getElementById("addSlitLampModal").style.display = "none";
  }
  viewimagedata: any = [];
  ImageViewer(type) {
    if (this.camexamid > 0) {
      this.captures = [];
      this.imagearrayshowing = [];
      this.emrservice.GetSlitLampImageDetailByIdByExamId(0, this.camexamid).pipe(takeUntil(this.destroyfinding$)).subscribe((item: any) => {
        if (item.length > 0) {
          for (var i = 0; i < item.length; i++) {
            let payload = {
              "description": item[i].description,
              "eye": item[i].eye,
              "fK_ExamID": item[i].fK_ExamID,
              "imageName": item[i].imageName,
              "pK_TranID": item[i].pK_TranID,
              "ischecked": false
            }
            this.captures.push(payload);
          }
          if (type == 0) {

            this.enablebtnSection = true;
            this.imageviewertype = 1;
            this.viewimagedata = this.captures.filter(item => item.eye == this.actvateeye && item.fK_ExamID == this.camexamid);
            this.viewimagedata[0].ischecked = true;
            if (this.viewimagedata.length > 0) {
              this.get_old_photo(this.camexamid, this.viewimagedata[0]?.imageName
              )
            }
          }

        } else {
          this.dashboardService.openSnackBar("Please capture image first", "ok")
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }


  }
  deleteImage(arrayobj: any) {

    this.saveimageobject = {};
    this.saveimageobject = arrayobj;
    this.opdvisitService.dataSource = this.opdvisitService.dataSource.filter(item => item.documentName.toLowerCase() == arrayobj.imageName.toLowerCase());
    this.captures = this.captures.filter(item => item.imageName != arrayobj.imageName);
    this.viewimagedata = this.viewimagedata.filter(item => item.imageName != arrayobj.imageName);
    if (this.imagearrayshowing.length > 0) {
      this.imagearrayshowing = this.imagearrayshowing.filter(item => item.imageName != arrayobj.imageName);
    }
    this.saveimageData(1);
  }
  selectsaveImage(event: MatCheckboxChange, arraydata: any, index: any) {

    //   if(arraydata.pK_TranID >0 ){
    this.viewimagedata[index].ischecked = event.checked;
    if (event.checked == true) {
      this.get_old_photo(this.camexamid, arraydata.imageName);
    } else {
      this.imagearrayshowing = this.imagearrayshowing.filter(x1 => x1.imageName != arraydata.imageName);
    }

  }
  saveimageData(type) {

    this.saveimageobject.isEdit = this.saveimageobject.pK_TranID > 0 ? true : false;
    const removeimage = this.captures.length > 0 ? this.captures.filter(item => item.imageName.toLowerCase() != this.saveimageobject.imageName.toLowerCase()) : this.captures;
    const removedata = this.viewimagedata.length > 0 ? this.viewimagedata.filter(item => item.imageName.toLowerCase() != this.saveimageobject.imageName.toLowerCase()) : this.viewimagedata;
    this.captures = removeimage;
    this.viewimagedata = removedata;
    this.saveimageobject.isDelete = false;
    let payload = {
      "SlitLampImageDetailDto": this.saveimageobject
    }
    if (this.saveimageobject.pK_TranID == 0 && type == 0) {
      this.showspinner1 = true;
      this.emrservice.InsertSlitLampImageDetail(payload).pipe(takeUntil(this.destroyfinding$)).subscribe((item: any) => {
        if (item.statusCode == 1) {
          const imageformat = item.id + '.jpeg'
          this.uploadImage(imageformat);

        }
      }, err => {
        this.showspinner1 = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else if (type == 1) {
      this.saveimageobject.isDelete = true;
      this.saveimageobject.isEdit = true;
      if (this.saveimageobject.pK_TranID == 0) {
        this.saveimageobject = this.viewimagedata.length > 0 ? this.viewimagedata[0] : {};
        return this.dashboardService.openSnackBar("Delete Successfully", "OK");

      } else {
        this.showspinner1 = true;
        this.emrservice.InsertSlitLampImageDetail(payload).subscribe((item: any) => {
          if (item.statusCode == 1) {
            this.deletepatientphoto(this.saveimageobject.fK_ExamID);
            this.saveimageobject = this.viewimagedata.length > 0 ? this.viewimagedata[0] : {};
          }
        }, err => {
          this.showspinner1 = false;
        })
      }

    }

  }

  uploadImage(docname: any) {
    const formData = new FormData();
    if (this.authservice.webstorageConfigobj.storageType != null && this.authservice.webstorageConfigobj.storageType != undefined) {
      if (this.authservice.webstorageConfigobj.imageFileSize != null && this.authservice.webstorageConfigobj.imageFileSize != undefined && Number(this.authservice.webstorageConfigobj.imageFileSize) > 0) {
        if (Number(this.authservice.webstorageConfigobj.imageFileSize) * 1024 >= this.saveimageobject.file.size) {

          formData.append('file', this.saveimageobject.file);
          formData.append('documentname', docname);
          formData.append('patientid', this.saveimageobject.fK_ExamID.toString());
          formData.append('branchId', this.authservice.Loggeduser.branchid.toString());
          formData.append('DocumentType', 'SLITLAMP');
          formData.append('FolderNameMain', 'SLITLAMP');
          formData.append('PkTranId', '0');
          formData.append('ActionType', "UPLOAD");
          if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'server') {
            this.imageWorkupService.uploadDoc(formData).pipe(takeUntil(this.destroyfinding$))
              .subscribe(
                data => this.successfileupload(data), err => this.failedfileupload(err))
          } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
            this.imageWorkupService.uploadAzureDoc(formData)
              .subscribe(
                data => this.successfileupload(data), err => this.failedfileupload(err))
          } else if (this.authservice.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

          } else {
            this.showspinner1 = false;
            this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
          }
        } else {
          this.showspinner1 = false;
          this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authservice.webstorageConfigobj.documentFileSize + ' Kb', "OK");
        }
      } else {
        this.showspinner1 = false;
        this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
      }
    } else {
      this.showspinner1 = false;
      this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
    }

  }
  failedfileupload(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  successfileupload(data) {
    // this.ImageViewer();
    this.showspinner1 = false;
    this.dashboardService.openSnackBar("Successfully image uploaded", "OK");
  }
  deletepatientphoto(patid: any) {

    if (patid > 0) {

      if (this.opdvisitService.dataSource.length > 0) {
        let payload = {
          "PatientDocumentDetail": {
            "ActionType": "DELETE",
            "Pk_TranId": this.opdvisitService.dataSource[0].pk_TranId,
            "Fk_BranchId": this.opdvisitService.dataSource[0].fk_BranchId,
            "Fk_RegId": this.opdvisitService.dataSource[0].fk_RegId,
            "Fk_CreatedById": this.authservice.Loggeduser.userid,
            "DocumentType": this.opdvisitService.dataSource[0].documentType,
            "DocumentName": this.opdvisitService.dataSource[0].documentName,
            "DocumentURL": this.opdvisitService.dataSource[0].documentURL,
            "StorageType": this.opdvisitService.dataSource[0].storageType
          }
        }
        if (this.opdvisitService.dataSource[0].storageType.toLowerCase() == 'server') {
          this.ipdservice.deleteServerPatientDocument(payload).pipe(takeUntil(this.destroyfinding$)).subscribe(
            data => this.success_delete_image(data), err => this.failed_doc_delete(err));
        } else if (this.opdvisitService.dataSource[0].storageType.toLowerCase() == 'azure') {
          this.ipdservice.deleteAzurePatientDocument(payload).subscribe(
            data => this.success_delete_image(data), err => this.failed_doc_delete(err));
        }
      } else {
        this.showspinner1 = false;
        this.dashboardService.openSnackBar("No Record Found", "OK");
      }
    }
    else {
      this.showspinner1 = false;
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  success_delete_image(data) {
    // this.ImageViewer();
    this.showspinner1 = false;
    this.dashboardService.openSnackBar("Delete Successfully", "OK");

  }

  failed_doc_delete(err) {
    this.showspinner1 = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  get_old_photo(examid: any, imagename: any) {
    this.opdvisitService.dataSource = [];
    this.imageWorkupService.getAzureImagedata(examid, this.authservice.Loggeduser.branchid, 'SLITLAMP').subscribe(
      (data: any) => {

        if (data.length > 0 && imagename != 0) {
          this.opdvisitService.dataSource = data;

          const getsingle = data.filter(item => item.documentName.toLowerCase() == imagename.toLowerCase());
          if (getsingle.length > 0) {
            this.saveimageobject.imageLink = getsingle[0].fbLong
            let payload = {
              "imageLink": getsingle[0].fbLong,
              "imageName": imagename
            }
            this.imagearrayshowing.push(payload);

          }

        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });


  }
  transferPreviousRecordModal() {

    if (this.opdvisitService.visitdates.length > 1) {
      this.showspinner = true;
      this.emrservice.GetPreSetting(this.authservice.Loggeduser.branchid,
        this.authservice.Loggeduser.userid,
        this.selectReportValue).pipe(takeUntil(this.destroyfinding$)).subscribe(item => {
          this.prescriptionSetting = [];
          this.PrintList = [];
          this.prescriptionSetting = item;
          this.PrintList = this.prescriptionSetting;
          if (this.PrintList.length > 0) {
            this.transfermaindata(this.PrintList);
          }
          this.showspinner = false;
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });


    } else {
      this.showspinner = false;
      this.dashboardService.openSnackBar("Previous Record Not Found", "OK");
    }
  }
  transfermaindata(opdsettingArray: any) {

    // let visitid = this.opdvisitService.visitdates[1].fK_VisitId;
    // let examid = this.opdvisitService.visitdates[1].pK_ExamId;
    // let docid = this.opdvisitService.visitdates[1].doctorId
    // if (examid > 0) {
    if (opdsettingArray.length > 0) {
      const checkfindingsetting = opdsettingArray.filter(xy => xy.colName.toLowerCase() == 'clearfindings')[0]?.colValue;
      if (checkfindingsetting == false) {
        this.emrservice.Gettransferfindingreocrdregid(this.opdvisitService.patientdetails.pkRegId).pipe(takeUntil(this.destroyfinding$)).subscribe((data: any) => {
          if (data.length > 0) {
            //  const filterarrayexamid = data.filter(xy => xy.fK_ExamId == examid);
            //  if (data.length > 0) {
            this.emrservice.enabledisablebtn = false;
            data?.forEach(item => {
              this.newlistarrray.push({
                pK_TempExamDetailId: 0,
                fK_TemplateId: 0,
                fk_FindingId: item.fk_FindingId,
                pk_SynchId: item.pk_SynchId,
                findingName: item.findingName,
                examValues1: item.examValues1,
                examValues2: item.examValues2,
                specification: item.findingName,
                findingSubGroup: null,
                isHidden: false,
                isEdit: false
              });
            });
            this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
              if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
                unique.push(o);
              }
              return unique;
            }, []);
            this.findings_ds = new MatTableDataSource(this.newlistarrray.slice())
            // }
          } else {
            this.dashboardService.openSnackBar("Previous Examination Record Not Found", "OK");
          }

        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
      const checkMedicinesetting = opdsettingArray.filter(xy => xy.colName.toLowerCase() == 'clearprescription')[0]?.colValue;
      if (checkMedicinesetting == false) {
        this.emrservice.GettransferMedincereocrdregid(this.opdvisitService.patientdetails.pkRegId).pipe(takeUntil(this.destroyfinding$)).subscribe((data1: any) => {

          if (data1.length > 0) {
            //  const mfilterarrayexamid = data1.filter(xy => xy.fK_ExamId == examid);
            this.emrservice.transferArrayMedicine.next(data1);
          } else {
            this.dashboardService.openSnackBar("Previous Medicine Record Not Found", "OK");
          }

        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
      const checkdiagonisi = opdsettingArray.filter(xy => xy.colName.toLowerCase() == 'cleardiagnosis')[0]?.colValue;
      if (checkdiagonisi == false) {
        this.emrservice.Gettransferdaigonsisreocrdregid(this.opdvisitService.patientdetails.pkRegId).pipe(takeUntil(this.destroyfinding$)).subscribe((data2: any) => {
          if (data2.length > 0) {
            //  const dfilterarrayexamid = data2.filter(xy => xy.fK_ExamId == examid);
            this.emrservice.transferArraydiagonsis.next(data2);
          } else {
            this.dashboardService.openSnackBar("Previous Diagnosis Record Not Found", "OK");
          }
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
    } else {
      this.dashboardService.openSnackBar("Please set Prescription Setting data", "OK");
    }
    // } else {
    //   this.dashboardService.openSnackBar("Previous Record Not Found", "OK");
    // }
  }
  closedialog() {
    this.dialogRef.close();
  }
  //master save 
  SaveDrworkup() {
    this.showspinner = true;
    if (this.emrservice.examid > 0) {
      this.emrservice.notifyComponents();
    } else {
      this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.emrservice.examid ? this.emrservice.examid : 0;
      this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
      this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
      this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
      this.opdvisitService.patientDrdetaill[0].isEdit = this.emrservice.examid > 0 ? true : false;
      let payload = {

        DrExam: {
          ...this.opdvisitService.patientDrdetaill[0]

        },

        DrFinding: []
        ,
        DrDiag: [],
        DrPrescrip: [
        ],
        DrInvest: []
        , DrSurgery: []
      }

      this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroyfinding$)).subscribe(data => {
        this.showspinner = false;
        if (data['statusCode'] == 1) {
          this.examid = data['id'];
          this.emrservice.examid = data['id'];
          this.emrservice.notifyComponents();
        } else if (data['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Already exists in the list", "OK");
        }

      }, err => {
        this.showspinner = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }

      });
    }
  }

}
